import { Accordion, AccordionDetails, Box, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import CustomAccordion from "./CustomAccordion";
import SearchTextField from "./SearchTextField";
import Pagination from "../pages/protected/home/components/Pagination";

interface Request {
  id: string;
  state: string;
  createdAt: string;
  processDefinitionName: string;
  nup?: string;
  tenantName: string;
}

interface RequestsAccordionProps {
  myRequests: { content: Request[] };
  processId?: string;
}

const RequestsAccordion: React.FC<RequestsAccordionProps> = ({
  myRequests,
  processId,
}) => {
  const { t } = useTranslation();
  const [requests, setRequests] = useState<Request[] | null>(
    myRequests.content,
  );
  const [page, setPage] = useState(0);
  const itemsPerPage = 10;

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    const filteredRequests = myRequests.content.filter((request) =>
      request.processDefinitionName.toLowerCase().includes(searchTerm),
    );
    setRequests(filteredRequests);
  };

  return (
    <>
      <SearchTextField
        handleSearch={handleSearch}
        placeholder={t("home.searchPlaceholder")}
        title={t("home.searchTitle")}
      />
      <Accordion className="accordion" defaultExpanded>
        <AccordionDetails>
          {typeof myRequests === "object" && myRequests.content.length > 0 ? (
            <>
              {requests
                ?.slice(page * itemsPerPage, (page + 1) * itemsPerPage)
                .map(
                  ({
                    id,
                    state,
                    createdAt,
                    processDefinitionName,
                    nup,
                    tenantName,
                  }) => (
                    <CustomAccordion
                      createdAt={createdAt}
                      defaultExpanded={processId === id}
                      key={id}
                      requestId={id}
                      subtitle={state}
                      tenantName={tenantName}
                      title={
                        nup
                          ? `${nup} - ${processDefinitionName}`
                          : processDefinitionName
                      }
                    />
                  ),
                )}
            </>
          ) : (
            <Typography variant="body1">
              {t("home.noRequests")}
            </Typography>
          )}
        </AccordionDetails>
        {requests?.length === 0 ? (
          <Box sx={{ textAlign: "center", padding: "16px" }}>
            <Typography color="text.secondary" variant="body1">
              {t("home.noCategory")}
            </Typography>
          </Box>
        ) : (
          <Pagination
            itemsPerPage={itemsPerPage}
            page={page}
            setPage={setPage}
            totalItems={requests?.length || 0}
          />
        )}
      </Accordion>
    </>
  );
};

export default RequestsAccordion;
